import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import facebook from '../../images/Footer/facebook.png';
import github from '../../images/Footer/github.png';
import linkedin from '../../images/Footer/linkedin.png';
import logo from '../../images/Footer/logo.svg';
import twitch from '../../images/Footer/twitch.png';
import './Footer.scss';

const Footer = () => (
    <footer className="footer-container">
        <Container>
            <Row>
                <Col xxl={3} md={6} className="mb-3" data-aos="zoom-in-up" data-aos-duration="1500">
                    <div>
                        <div className="footer-logo">
                            <img src={logo} alt="" />
                            <h4>TechTack</h4>
                        </div>
                        <div>
                            <p>more recently with desktop publishing software like versions</p>
                            <p>4188 North Street</p>
                            <p> Eastern Standard Time (EST)</p>
                        </div>
                        <div className="icons-footer1">
                            <a href="http://example.com/" target="_blank" rel="noreferrer">
                                <img src={facebook} alt="" />
                            </a>
                            <a href="http://example.com/" target="_blank" rel="noreferrer">
                                <img src={linkedin} alt="" />
                            </a>
                            <a href="http://example.com/" target="_blank" rel="noreferrer">
                                <img src={github} alt="" />
                            </a>
                            <a href="http://example.com/" target="_blank" rel="noreferrer">
                                <img src={twitch} alt="" />
                            </a>
                        </div>
                    </div>
                </Col>
                <Col xxl={2} md={3} className="mb-3" data-aos="zoom-in-up" data-aos-duration="1500">
                    <h4>Support</h4>
                    <br />
                    <p>Pricing</p>
                    <p>Documentation</p>
                    <p>Sitemap</p>
                    <p>Documentation</p>
                    <p>Documentation</p>
                </Col>
                <Col xxl={2} md={3} className="mb-3" data-aos="zoom-in-up" data-aos-duration="1500">
                    <h4>Company</h4>
                    <br />
                    <p>About Us</p>
                    <p>Partners</p>
                    <p>Testimonials</p>
                    <p>Portfolio</p>
                </Col>
                <Col xxl={2} md={3} className="mb-3" data-aos="zoom-in-up" data-aos-duration="1500">
                    <h4>Company</h4>
                    <br />
                    <p>About Us</p>
                    <p>Partners</p>
                    <p>Testimonials</p>
                    <p>Portfolio</p>
                </Col>
                <Col xxl={3} md={6} className="mb-3" data-aos="zoom-in-up" data-aos-duration="1500">
                    <h4>Subscribe To Our Newsletter</h4>
                    <p>more recently with desktop publishing like Aldus PageMaker including</p>
                    <form action="">
                        <input
                            type="email"
                            className="footer-input"
                            placeholder="Enter Your Mail"
                            required
                        />{' '}
                        <button className="footer-btn" type="submit">
                            Subscribe
                        </button>
                    </form>
                </Col>
            </Row>
            <div className="footer-icon mt-5">
                <div>
                    <p>&copy; {new Date().getFullYear()} Crimson, Inc All rights reserved</p>
                </div>
                <div className="icons-footer">
                    <a href="http://example.com/" target="_blank" rel="noreferrer">
                        <img src={facebook} alt="" />
                    </a>
                    <a href="http://example.com/" target="_blank" rel="noreferrer">
                        <img src={linkedin} alt="" />
                    </a>
                    <a href="http://example.com/" target="_blank" rel="noreferrer">
                        <img src={github} alt="" />
                    </a>
                    <a href="http://example.com/" target="_blank" rel="noreferrer">
                        <img src={twitch} alt="" />
                    </a>
                </div>
            </div>
        </Container>
    </footer>
);

export default Footer;
